const toApiFormat = (type, action) => (`api/${type}_${action}`);

export const REQUEST = 'REQUEST';
export const SUCCESS = 'SUCCESS';
export const FAILURE = 'FAILURE';

export const createApiActionTypes = type => ({
  REQUEST: toApiFormat(type, REQUEST),
  SUCCESS: toApiFormat(type, SUCCESS),
  FAILURE: toApiFormat(type, FAILURE),
});



// WEBPACK FOOTER //
// ./src/helpers/actions.js